import React from "react";
import { Props } from "./types";
import { ButtonTagForm } from "./buttonTagForm";
import { Tag } from "./tag";
import styles from "./styles.scss";

function TagList({ tags, assignTag, removeTag }: Props) {
  return (
    <div className={styles.tagList}>
      {!!tags.length ? (
        <div className={styles.list}>
          {tags.map((tag) => (
            <Tag key={tag.name} tag={tag} remove={removeTag} />
          ))}
          <div className={styles.buttonWrapper}>
            <ButtonTagForm tags={tags} assignTag={assignTag} />
          </div>
        </div>
      ) : (
        <div className={styles.buttonWrapper}>
          <ButtonTagForm tags={tags} assignTag={assignTag} />
        </div>
      )}
    </div>
  );
}

export { TagList };
